export default {
  title: 'Teams',
};
